// ================================================================
// Email Node — Configuration Schema
// ================================================================
// پشتیبانی از سه provider:
//   - Google (OAuth 2.0) — نیاز به backend برای token exchange
//   - Microsoft (OAuth 2.0) — نیاز به backend
//   - IMAP/SMTP — اتصال دستی با host/port/credentials

export const emailConfigSchema = {
  fields: [
    // ───────────────────────────────────────────
    // 1) انتخاب provider
    // ───────────────────────────────────────────
    {
      key: 'provider',
      type: 'select',
      labelKey: 'nodes.email.fields.provider',
      placeholderKey: 'nodes.email.placeholders.provider',
      required: true,
      options: [
        { value: 'google',    labelKey: 'nodes.email.options.google' },
        { value: 'microsoft', labelKey: 'nodes.email.options.microsoft' },
        { value: 'imap',      labelKey: 'nodes.email.options.imap' }
      ]
    },

    // ───────────────────────────────────────────
    // 2a) Google OAuth
    // ───────────────────────────────────────────
    {
      key: 'googleConnection',
      type: 'oauth',
      labelKey: 'nodes.email.fields.connection',
      showIf: { provider: 'google' },
      provider: {
        id: 'google',
        nameKey: 'nodes.email.providers.google',
        icon: 'mail',
        color: '#EA4335',
        authUrl: '/api/auth/google/start'  // backend endpoint
      }
    },

    // ───────────────────────────────────────────
    // 2b) Microsoft OAuth
    // ───────────────────────────────────────────
    {
      key: 'microsoftConnection',
      type: 'oauth',
      labelKey: 'nodes.email.fields.connection',
      showIf: { provider: 'microsoft' },
      provider: {
        id: 'microsoft',
        nameKey: 'nodes.email.providers.microsoft',
        icon: 'mail',
        color: '#0078D4',
        authUrl: '/api/auth/microsoft/start'
      }
    },

    // ───────────────────────────────────────────
    // 2c) IMAP — اتصال دستی
    // ───────────────────────────────────────────
    {
      key: 'imapEmail',
      type: 'email',
      labelKey: 'nodes.email.fields.emailAddress',
      placeholderKey: 'nodes.email.placeholders.emailAddress',
      required: true,
      showIf: { provider: 'imap' }
    },
    {
      key: 'imapPassword',
      type: 'password',
      labelKey: 'nodes.email.fields.password',
      placeholderKey: 'nodes.email.placeholders.password',
      required: true,
      showIf: { provider: 'imap' },
      help: 'nodes.email.help.appPassword'
    },
    {
      key: 'imapHost',
      type: 'text',
      labelKey: 'nodes.email.fields.imapHost',
      placeholderKey: 'nodes.email.placeholders.imapHost',
      required: true,
      showIf: { provider: 'imap' },
      icon: 'dns'
    },
    {
      key: 'imapPort',
      type: 'number',
      labelKey: 'nodes.email.fields.imapPort',
      placeholderKey: 'nodes.email.placeholders.imapPort',
      required: true,
      showIf: { provider: 'imap' },
      defaultValue: 993,
      icon: 'lan'
    },
    {
      key: 'smtpHost',
      type: 'text',
      labelKey: 'nodes.email.fields.smtpHost',
      placeholderKey: 'nodes.email.placeholders.smtpHost',
      required: true,
      showIf: { provider: 'imap' },
      icon: 'send'
    },
    {
      key: 'smtpPort',
      type: 'number',
      labelKey: 'nodes.email.fields.smtpPort',
      placeholderKey: 'nodes.email.placeholders.smtpPort',
      required: true,
      showIf: { provider: 'imap' },
      defaultValue: 587,
      icon: 'lan'
    },
    {
      key: 'useSsl',
      type: 'checkbox',
      labelKey: 'nodes.email.fields.useSsl',
      showIf: { provider: 'imap' },
      defaultValue: true
    }
  ]
};
